import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

interface AddAgentContextDialogProps {
  open: boolean;
  isUploading: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (files: { mediaFile: File | null; contextFile: File | null }) => void;
}

export const AddAgentContextDialog = ({
  open,
  isUploading,
  onOpenChange,
  onSubmit,
}: AddAgentContextDialogProps) => {
  const [contextFile, setContextFile] = useState<File | null>(null);
  const [mediaFile, setMediaFile] = useState<File | null>(null);

  useEffect(() => {
    if (!open) {
      setContextFile(null);
      setMediaFile(null);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[520px]">
          <DialogHeader>
            <DialogTitle>
              Add files as context
            </DialogTitle>
            <DialogDescription>
              You can add files as context that your agent can use and present
              to students during the interview or as additional information
              when generating your playbook.
            </DialogDescription>
          </DialogHeader>

          <div className="">
            <div className="space-y-2">
              <div className="text-sm font-semibold">
                Used during interview
              </div>
              <Input
                type="file"
                accept="image/jpeg,image/png,video/mp4,video/mpeg"
                onChange={(e) => setMediaFile(e.target.files?.[0] || null)}
              />
              <p className="text-sm leading-normal text-muted-foreground">
                Supports JPEG and PNG formats. Use context by
                referencing the respective file in your Instructions by typing @
                to open the file picker and selecting them.
              </p>
            </div>

            <div className="border-t my-4" />

            <div className="space-y-4">
              <div className="text-sm font-semibold">
                Used when generating playbook
              </div>
              <Input
                type="file"
                accept="application/pdf,image/jpeg,image/png"
                onChange={(e) => setContextFile(e.target.files?.[0] || null)}
              />
              <p className="text-sm text-muted-foreground">
                Supports PDF, JPEG and PNG formats.
              </p>
            </div>
          </div>

          <DialogFooter className="mt-2flex-row justify-end gap-3">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Close
            </Button>
            <Button
              className="bg-black text-white hover:bg-black/90"
              onClick={() => onSubmit({ mediaFile, contextFile })}
              disabled={isUploading}
            >
              {isUploading ? "Uploading..." : "Add context"}
            </Button>
          </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
